export default __webpack_public_path__ + "static/media/gallery_03.16199f4b.jpg";